// App Imports
import React, { lazy, Suspense, Fragment } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import Routes from "./Routes"
import axios from "axios";
import * as serviceWorker from "./serviceWorker";
import { store } from "./setup/store";
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import './assets/base.scss';
import CssBaseline from '@mui/material/CssBaseline';
// checks if cached token and user objects in cookie in event of hard sesh refresh
import {
  setUserAndToken,
  loginSetUserLocalStorageAndCookie,
  getRefreshToken,
} from "./modules/user/api/actions";
// FontAwesome removed - using MUI icons instead
// FontAwesome library setup removed - now using MUI icons



// User Authentication: This checks storage on the current tokens in the browser and reloads that into the current state.
const token = window.localStorage.getItem("token");
const refreshToken = window.localStorage.getItem("refreshToken");

if (token && token !== "undefined" && token !== "") {
  const user = JSON.parse(window.localStorage.getItem("user"));
  if (token) {
    axios.defaults.headers.common["x-access-limit"] = 30;
    axios.defaults.headers.common["x-access-token"] = token;
  }
  if (user) {
    // Dispatch action
    store.dispatch(setUserAndToken(token, user));
    loginSetUserLocalStorageAndCookie(token, user);
  }
}

console.log(
  "********************* REACT-DOM Main App Render Called *******************"
);

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <CssBaseline />
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
